import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {Lang} from 'yougile-lang'
import {unsplashStore} from '@components/board-appearance/unsplash/unsplash-store'
import {Loader} from '@components/common/base/loader'
import {TwTitleSecondary} from './containers'
import {OurSkins} from './our-skins'
import {UnsplashSkins} from './unsplash-skins'

export const ProfileSkinContent = observer(() => {
  const searchOn = unsplashStore.isSearch

  const emptyResults = searchOn && unsplashStore.state.totalPages === 0
  if (emptyResults) {
    return (
      <TwTitleSecondary>
        {Lang.msg.boardAppearance.emptyResults}
      </TwTitleSecondary>
    )
  }

  const loadUnsplash = searchOn && unsplashStore.state.waitFirstPage
  if (loadUnsplash) {
    return (
      <div className="flex justify-center w-full py-64">
        <Loader size="xlarge" />
      </div>
    )
  }

  const error = searchOn ? unsplashStore.state.error : undefined
  const unsplashErrorRequestLimit = error?.includes('429')

  return (
    <>
      {unsplashErrorRequestLimit && (
        <TwTitleSecondary className="mb-8">
          {Lang.msg.boardAppearance.unsplashErrorRequestLimit}
        </TwTitleSecondary>
      )}
      <div className={'px-2 mx-[-2px] py-2 my-[-2px]'}>
        {searchOn ? <UnsplashSkins reachedLimit={!!error} /> : <OurSkins />}
      </div>
    </>
  )
})
